import React from 'react';
import { Logger } from '../utils';
import { useMediaSet } from 'use-media-set';
import PropTypes from 'prop-types';
import { Player } from '@lottiefiles/react-lottie-player';
import takeoffLandscape from '../../../../lotties/takeoffLandscape.json';
import takeoffPortrait from '../../../../lotties/takeoffPortrait.json';

const AnimationPerformanceTest = ({ performanceTestComplete }) => {
  const animationStartTime = Date.now();

  const mediaStates = useMediaSet({
    desktop: { minWidth: 1024 },
  });
  const takeoff = mediaStates.has('desktop')
    ? takeoffLandscape
    : takeoffPortrait;

  return (
    <>
      <div className="waiting-room-welcome-popover-overlay">
        <Player
          autoplay
          onEvent={event => {
            if (event === 'complete') {
              const animationEndTime = Date.now();

              Logger(
                'UI.Twilio.WaitingRoom.PlayPerformanceTestAnimation',
                new Date(),
                null,
                mediaStates.has('desktop')
                  ? 'takeoffLandscape'
                  : 'takeoffPortrait'
              );

              performanceTestComplete(animationStartTime, animationEndTime);
            }
          }}
          src={takeoff}
          style={{ height: '100%', width: '100%' }}
        />
      </div>
    </>
  );
};

AnimationPerformanceTest.defaultProps = {
  performanceTestComplete: () => {},
};

AnimationPerformanceTest.propTypes = {
  performanceTestComplete: PropTypes.func,
};

export default AnimationPerformanceTest;
